import { render } from "./NewsPublicCard.vue?vue&type=template&id=f76cf9e6&scoped=true"
import script from "./NewsPublicCard.vue?vue&type=script&lang=js"
export * from "./NewsPublicCard.vue?vue&type=script&lang=js"

import "./NewsPublicCard.vue?vue&type=style&index=0&id=f76cf9e6&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76cf9e6"]])

export default __exports__